import { render, staticRenderFns } from "./ArtPerfBibliogr.vue?vue&type=template&id=f4e754c2&"
import script from "./ArtPerfBibliogr.vue?vue&type=script&lang=ts&"
export * from "./ArtPerfBibliogr.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports